// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from './assets/lang/en.json';
import translationFR from './assets/lang/fr.json';
import translationUA from './assets/lang/ua.json';
import translationSI from './assets/lang/si.json';

// Traductions
const resources = {
    en: {
        translation: translationEN
    },
    fr: {
        translation: translationFR
    },
    ua: {
        translation: translationUA
    },
    si: {
        translation: translationSI
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;